import config from '../../config.js'
export default {
	'actual-amount-of-cardamom': `${config['actual-amount-of-cardamom'].es}`,
	'cardamom-is-restricted-to-sorting': `${config['cardamom-is-restricted-to-sorting'].es}`,
	'remaining-qty': 'Cantidad restante',
	'total-sales': 'Ventas totales',
	'sale-balance': 'Cantidad esperada',
	'sale-balance-table': 'Saldo esperado',
	'items-in-inventory': 'Artículos listos',
	'inventory-qty': 'Cantidad en inventario',
	'available-to-sell': 'Capaz de vender'
}